document.addEventListener('DOMContentLoaded', function() {
    const radioOneTime = document.getElementById('selling-plan-type--onetime');
    const radioSubscribe = document.getElementById('selling-plan-type--subscribe');
    const deliverySelectContainer = document.getElementById('selling-plan-select__container');
    const deliverySelect = document.getElementById('selling-plan-select');
    const quantityEl = document.querySelector('.product-quantity-select');
    const variantIdEl = document.getElementById('selected-variant-id');
    const originalPriceEl = document.getElementById('compare-at-total');
    const totalPriceEl = document.getElementById('price-total');
    const pricePerBagEl = document.getElementById('price-per-bag');
    const selects = document.querySelectorAll('.product-input-selects select');
    const discountLabel = document.getElementById('discount-label');
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const loadingSpinner = document.querySelector('.loading-overlay__spinner');
    let planId = null;
    let quantity = quantityEl.value
    let variantId = variantIdEl.value;
    let variantPrice = parseFloat(getSelectedVariantPrice(variantId));
    let discount = 0;
    let discountType = 'percentage';
    let discountedPrice;
    let applyDiscount = false;

    function getSelectedVariantPrice(variantId) {
        return variantsList.find(variant => variant.id == variantId).price / 100;
    }      

    function handleOneTimeClick() {
        deliverySelectContainer.classList.add('hidden');
        planId = null;
        applyDiscount = false;
        updatePrice();
    }

    function handleSubscribeClick() {
        deliverySelectContainer.classList.remove('hidden');
        planId = deliverySelect.value;
        applyDiscount = true;
        updatePrice();
    }

    function handleSelectChange(e) {
        e.preventDefault();
        updatePrice();
    }

    function handleDeliverySelectChange(){
        planId = deliverySelect.value;

        if(discount > 0){
            const discountValue = discountType == 'percentage' ? `${discount}%` : `$${(discount/100).toFixed(2)}`;
            discountLabel.innerHTML = discountValue;
        } else {
            discountLabel.innerHTML = '';
        }
    }

    function updatePrice(){
        quantity = quantityEl.value
        variantId = variantIdEl.value;
        variantPrice = parseFloat(getSelectedVariantPrice(variantId));    
       
        if(applyDiscount){
            discount = deliverySelect.selectedOptions[0].dataset.discountValue ? parseInt(deliverySelect.selectedOptions[0].dataset.discountValue) : 0;
            discountType = deliverySelect.selectedOptions[0].dataset.discountType ? deliverySelect.selectedOptions[0].dataset.discountType : 'percentage';
            finalPrice = discountType == 'percentage' ? (variantPrice * ( 1 - (discount/100))).toFixed(2) : (variantPrice - (discount/100)).toFixed(2);
            originalPriceEl.classList.remove('hidden');
        } else {
            discount = 0;
            discountType = 'percentage';
            originalPriceEl.classList.add('hidden');
            finalPrice = variantPrice;
        }
        
        originalPriceEl.innerHTML = `$${ (variantPrice * quantity).toFixed(2) }`;
        totalPriceEl.innerHTML = `$${ (finalPrice * quantity).toFixed(2) }`;

        if(pricePerBagEl){
            pricePerBagEl.innerHTML = `${ finalPrice }`;
        }
    }

    function handleAddToCartClick(e){
        e.preventDefault();
        addProductToCart(variantId, quantity, planId);
    }

    function addProductToCart(id, qty, selling_plan_id) {
        loadingSpinner.classList.remove('hidden');

        let item = {
            'id': id,
            'quantity': qty
        };
        
        if (selling_plan_id) {
            item.selling_plan = selling_plan_id;
        }
        
        let formData = {
            'items': [item]
        };

        fetch('/cart/add.js', {
            method: 'POST',
            headers: {'content-Type': 'application/json'},
            body: JSON.stringify(formData)
        })
        .then(response => {
            loadingSpinner.classList.add('hidden');
            return response.json();
        })
        .catch((error) => {
            loadingSpinner.classList.add('hidden');
            console.error('Error:', error);
        });
    }

    function watchForVariantChange() {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type == 'attributes' && mutation.attributeName == 'value') {
                    updatePrice();
                }
            });
        });
        
        observer.observe(variantIdEl, {
            attributes: true,
        });
    }

    updatePrice();
    selects.forEach(function(select){ select.addEventListener('change', handleSelectChange) });
    watchForVariantChange();
    addToCartBtn.addEventListener('click', handleAddToCartClick);

    if(radioOneTime && radioSubscribe && deliverySelect){
        radioOneTime.addEventListener('click', handleOneTimeClick);
        radioSubscribe.addEventListener('click', handleSubscribeClick);    
        deliverySelect.addEventListener('change', handleDeliverySelectChange);            
    }
});
